
import { Component, Vue, ProvideReactive } from "vue-property-decorator";
import { apiOrderGetList, apiOrderGetMenuNumber } from "@/api/order";
import moment from "moment";
import { filteredObj, RequestPaging } from "@/utils/util";
import LsPagination from "@/components/ls-pagination.vue";

@Component({
  components: {
    LsPagination,
  },
})
export default class supplierManage extends Vue {
  $refs!: {};
  // data
  apiOrderGetList = apiOrderGetList;
  supplySelect = ""; // 1：手动添加供应商 2：供应商导入
  activeName: any = "待审核";
  tableLoading = false;
  isFold = false;
  activeVal = "0";
  form: any = {
    search_type: 5,
    search_sn: "",
    type: -1,
    search_status: "",
    status: "",
    is_express_sheet_apply: "",
    is_sku_out_of_stock: "",
    express_status: "",
    order_user_id: "",
    is_merge: "",
    is_apart: "",
    is_weight_out: "",
    is_sku_out: "",
    is_picking: "",
    sku_type: 0,
    merge_status: "",
    depot_id: "",
    country_id: "",
    is_warning: "",
    express_type: "",
    goods_id: "",
    spec_value_str: "",
  };

  selectionArr: Array<object> = [];

  isAllFold: boolean = true;
  pagerLists: any = [];

  arraySpanMethod({ row, column, rowIndex, columnIndex }: any) {
    if (columnIndex == 1) {
      return [1, 99];
    }
    if (columnIndex > 1) {
      return [0, 0];
    }
    if (columnIndex < 1) {
      return [1, 1];
    }
  }

  topValFilter(val: string) {
    // 订单列表头部显示当前选中位置
    switch (val) {
      case "0":
        return "全部";
      case "1":
        return "待审核";
      case "2":
        return "待处理";
      case "3":
        return "运单号申请";
      case "50":
        return "可合并";
      case "4":
        return "有货";
      case "9":
        return "可拣货";
      case "10":
        return "拣货中";
      case "5":
        return "缺货";
      case "6":
        return "发货异常";
      case "7":
        return "已发货";
      case "8":
        return "已作废";
      default:
        return "未知";
    }
  }

  // 已选择的id
  selectionIds: Array<object> = [];
  menuNumber: any = {
    status_1: 0,
    status_2: 0,
    status_3: 0,
    status_4: 0,
    status_5: 0,
    status_6: 0,
    status_7: 0,
    status_8: 0,
    status_9: 0,
    status_10: 0,
    status_11: 0,
    status_12: 0,
  };
  pickerOptions = {};
  pager = new RequestPaging();

  click_btn_obj: any = {
    "1": 0,
    "2": 1,
    "3": 1,
    "4": 1,
    "5": 0,
  };

  loadingTable() {
    this.tableLoading = true;
    setTimeout(() => {
      this.getOrderList(1);
      this.tableLoading = false;
    }, 600);
  }

  get computedOrderCount() {
    return this.selectionArr.length;
  }
  get computedOrderGoodsCount() {
    let goodsCount = 0;
    this.selectionArr.forEach((v: any) => {
      goodsCount += v.sku_data.length;
    });
    return goodsCount;
  }

  // 表格selection
  handleSelectionChange(e: any) {
    this.$set(this, "selectionArr", e);
  }

  getRowKeys(e: any) {
    return e.id;
  }

  handleTabClick() {
    // 查找菜单数量
    setTimeout(() => {
      this.getMenuNumber();
    }, 0);
    this.form.status = "";
    this.form.is_warning = "";
    this.form.is_sku_out_of_stock = "";
    this.form.is_express_sheet_apply = "";
    this.form.is_picking = "";
    this.form.express_status = "";
    this.form.merge_status = "";
    switch (this.activeVal) {
      case "0":
        this.form.status = "";
        this.form.is_sku_out_of_stock = "";
        this.form.is_express_sheet_apply = "";
        break;
      case "1":
        this.form.status = "3";
        break;
      case "2":
        this.form.status = "2";
        this.form.is_express_sheet_apply = "2";
        this.form.is_sku_out_of_stock = "2";
        this.form.express_status = "0";
        break;
      case "3":
        this.form.status = "2";
        this.form.is_express_sheet_apply = "1";
        this.form.express_status = "0";
        break;
      case "50":
        // this.form.status = '2'
        // this.form.is_express_sheet_apply = '1'
        this.form.merge_status = "1";
        break;
      case "4":
        this.form.status = "2";
        this.form.is_sku_out_of_stock = "1";
        this.form.express_status = "0";
        break;
      case "5":
        this.form.status = "2";
        this.form.is_sku_out_of_stock = "2";
        this.form.express_status = "0";
        break;
      case "6":
        // this.form.status = '2'
        // this.form.express_status = '3'
        this.form.is_warning = "1";
        break;
      case "7":
        this.form.status = "2";
        this.form.express_status = "1,2,3";
        break;
      case "8":
        this.form.status = "4";
        break;
      case "9":
        this.form.status = "2";
        this.form.is_sku_out_of_stock = "1";
        this.form.is_picking = "2";
        this.form.express_status = "0";
        break;
      case "10":
        this.form.status = "2";
        this.form.is_picking = "1";
        this.form.express_status = "0";
        break;
      case "12":
        this.form.status = "1";
        break;
      default:
        break;
    }
    this.loadingTable();
  }

  // 获取列表数据
  getOrderList(page?: any) {
    this.tableLoading = true;
    page && (this.pager.page = page);
    if (this.form.date && this.form.date !== "undefined") {
      this.form.start_time = moment(this.form.date[0]).format(
        "YYYY-MM-DD HH:mm:ss",
      );
      this.form.end_time = moment(this.form.date[1]).format(
        "YYYY-MM-DD HH:mm:ss",
      );
    } else {
      this.form.start_time = "";
      this.form.end_time = "";
    }

    let lsForm = JSON.parse(JSON.stringify(filteredObj(this.form)));
    delete lsForm.date;
    this.pager
      .request({
        callback: apiOrderGetList,
        params: { ...lsForm },
      })
      .then((res: any) => {
        this.tableLoading = false;
        this.pagerLists = res.lists.map((item: any) => ({
          ...item,
          is_fold_son_table: true,
          sku_info_list: [],
        }));

        for (let i = 0; i < res.lists.length; i++) {
          // 修改展开行的内容
          this.$set(
            this.pagerLists[i],
            "expand_data",
            res.lists[i]["sku_data"],
          );
          this.$set(
            this.pagerLists[i],
            "sku_info_list",
            res.lists[i]["sku_data"],
          );
        }
      })
      .catch((e) => {
        this.tableLoading = false;
      });
  }

  rowAllChange() {
    this.isAllFold = !this.isAllFold;
    for (let i = 0; i < this.pagerLists.length; i++) {
      this.rowTableChange(this.pagerLists[i], true);
    }
  }

  rowTableChange(row: any, mainSwitch?: Boolean) {
    // mainSwitch: 是否触发总开关
    let isFold = !row.is_fold_son_table;
    if (mainSwitch) {
      isFold = this.isAllFold;
    }
    row.is_fold_son_table = isFold;
    if (row.is_fold_son_table) {
      // 找到展开行的索引
      const index = this.pagerLists.indexOf(row);
      // this.$set(this.pagerLists[index], 'expand_data', row.sku_data)
      // this.$set(this.pagerLists[index], 'sku_info_list', row.sku_data)
      // this.getSkuListFn(row.id).then((r: any) => {
      //     // 修改展开行的内容
      //     this.$set(this.pagerLists[index], 'expand_data', r)
      //     this.$set(this.pagerLists[index], 'sku_info_list', r)
      // })
    } else {
      // 可以在这里添加折叠行时的操作，例如清空展开内容
      const index = this.pagerLists.indexOf(row);
      // this.$set(this.pagerLists[index], 'sku_info_list', [])
    }
  }
  async getMenuNumber() {
    await apiOrderGetMenuNumber().then((response: any) => {
      this.menuNumber = response;
    });
  }

  mounted() {
    // 页面加载完毕后执行的代码
    this.$nextTick(() => {
      this.getMenuNumber();
    });
    // 获取参数
    if (this.$route.query && this.$route.query.sn) {
      this.form.search_sn = this.$route.query.sn;
    }
    this.getOrderList(1);
  }
  // 搜索内容
  searchData(key: any, val: any) {
    if (key) {
      this.form[key] = val;
    }
    this.getMenuNumber();
    this.getOrderList(1);
  }

  reset() {
    this.form = {
      search_type: 1,
      search_sn: "",
      type: -1,
      search_status: "",
      status: "",
      is_express_sheet_apply: "",
      is_sku_out_of_stock: "",
      express_status: "",
      order_user_id: "",
      is_merge: "",
      is_apart: "",
      is_weight_out: "",
      is_sku_out: "",
      is_picking: "",
      sku_type: 0,
      merge_status: "",
      depot_id: "",
      country_id: "",
      express_type: "",
      goods_id: "",
      spec_value_str: "",
    };

    this.getOrderList(1);
  }
}
